export default __webpack_public_path__ + "static/media/logo-black.60bddbcf.svg";